export enum AppointmentCancelHandleAction {
  ChargePatientFee = 'charge-patient',
  WaivePatientFee = 'waive-patient',
  CourtesyFee = 'courtesy-fee',
}

interface FeeOptionConfig {
  title: string;
  description: string;
  subtitle: string;
}

export const getFeeOptionConfig = (
  value: AppointmentCancelHandleAction,
): FeeOptionConfig => {
  switch (value) {
    case AppointmentCancelHandleAction.WaivePatientFee:
      return {
        title: 'Waive Fee',
        description: 'Fee waived',
        subtitle: '•  No charge to patient\n•  No payment to provider',
      };
    case AppointmentCancelHandleAction.CourtesyFee:
      return {
        title: 'Courtesy Waiver',
        description: 'Fee waived',
        subtitle: '• No charge for patient\n• Provider will be paid',
      };
    case AppointmentCancelHandleAction.ChargePatientFee:
      return {
        title: 'Charge Fee',
        description: 'Fee charged',
        subtitle: '• Patient will be charged\n• Provider will be paid',
      };
    default:
      return {
        title: String(value),
        description: '',
        subtitle: '',
      };
  }
};

export const FEE_OPTIONS_DISPLAY_ORDER: AppointmentCancelHandleAction[] = [
  AppointmentCancelHandleAction.WaivePatientFee,
  AppointmentCancelHandleAction.CourtesyFee,
  AppointmentCancelHandleAction.ChargePatientFee,
];
